// extracted by mini-css-extract-plugin
module.exports = {"loaderBtn":"LoaderBtn_loaderBtn__2Xz65","btn_content":"LoaderBtn_btn_content__2wvuq","btn_content_offset":"LoaderBtn_btn_content_offset__3ySDd","loader":"LoaderBtn_loader__3Ypxn"};